import { render } from "./Hdqc.vue?vue&type=template&id=4c089e81"
import script from "./Hdqc.vue?vue&type=script&lang=js"
export * from "./Hdqc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__